import { createContext, useContext } from 'react';
var EventsContext = createContext({});
export var EventsProvider = EventsContext.Provider;
export function useEventInstance() {
    var runtime = useContext(EventsContext);
    if (!runtime) {
        throw new Error('useEventInstance must be use under `EventsProvider`');
    }
    return runtime;
}
export function useEvent(name) {
    var runtime = useEventInstance();
    if (!runtime[name]) {
        throw new Error("event name = " + name + " is not exist.");
    }
    return runtime[name];
}
